import { render, staticRenderFns } from "./TravelFeedbackSection.vue?vue&type=template&id=2c2f8d02&scoped=true&"
import script from "./TravelFeedbackSection.vue?vue&type=script&lang=js&"
export * from "./TravelFeedbackSection.vue?vue&type=script&lang=js&"
import style0 from "./TravelFeedbackSection.vue?vue&type=style&index=0&id=2c2f8d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f8d02",
  null
  
)

export default component.exports